import {
  getImageMediaIdByExerciseIdSelector,
  getVideoMediaIdByExerciseIdSelector
} from '@gymaholic/packages'
import { logUtil } from 'packages/src'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import MediaImage from 'containers/MediaImage'
import { getByIdExerciseSelector } from 'modules/workout/redux/selectors'
import getNameReduxUtil from 'modules/redux/utils/get-name'

export default function ExerciseMediaImage (props) {
  const {
    id,
    ...rest
  } = props
  const mediaVideoId = useSelector(getVideoMediaIdByExerciseIdSelector(id))
  const mediaImageId = useSelector(getImageMediaIdByExerciseIdSelector(id))
  const exercise = useSelector(getByIdExerciseSelector(id))
  const name = getNameReduxUtil(exercise)
  const mediaId = mediaImageId || mediaVideoId
  const debugProps = {
    exercise,
    id,
    mediaId,
    name,
    props
  }

  logUtil('ExerciseMediaImage').debug('[start] debugProps=', debugProps)

  return (
    <MediaImage
      id={mediaId}
      useThumbnail
      alt={name}
      {...rest}
    />
  )
}
